import request from './../../utilities/request';
import localStorageToken from './../../utilities/storage';

function get(page, query) {
  return request({
    url:    `/blog/list/page/${ page }`,
    headers: {'Authorization': localStorageToken()},
    method: 'GET',
    params:  query
  });
}

function create(values) {
  return request({
    url:    '/blog/save',
    headers: {'Authorization': localStorageToken()},
    method: 'POST',
    data:   values
  });
}

function update(id, values) {
  return request({
    url:    `/blog/update/${ id }`,
    headers: {'Authorization': localStorageToken()},
    method: 'PUT',
    data:   values
  });
}

function find(id) {
  return request({
    url:    `/blog/overview/${ id }`,
    headers: {'Authorization': localStorageToken()},
    method: 'GET'
  });
}

function remove(id) {
  return request({
    url:    `/blog/remove/${ id }`,
    headers: {'Authorization': localStorageToken()},
    method: 'DELETE'
  });
}

function categories() {
  return request({
    url:    `/blog/categories`,
    method: 'GET'
  });
}

const BlogService = {
  get, create, update, remove, find, categories
}

export default BlogService;
